import Reveal from "./Reveal";
import { APPLICATIONS } from "../../data/pwt";

export default function Applications() {
  return (
    <section
      id="applications"
      data-testid="applications-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-20">
          <Reveal className="col-span-12 md:col-span-7">
            <span className="overline">06 — Examples of ecosystem applications</span>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl tracking-tight text-[#0A140F] leading-[1.05]">
              How PWT partners
              <br />
              <span className="italic text-[#1A402B]">collaborate to deliver end-to-end solutions.</span>
            </h2>
          </Reveal>
        </div>

        <div className="space-y-16 md:space-y-20">
          {APPLICATIONS.map((app) => (
            <Reveal
              key={app.step}
              data-testid={`application-${app.step}`}
              className="grid grid-cols-12 gap-6 md:gap-10"
            >
              <div className="col-span-12 md:col-span-4">
                <div className="font-mono text-sm tracking-widest text-[#1A402B]">
                  Application {app.step}
                </div>
                <h3 className="mt-4 font-serif text-2xl md:text-4xl text-[#0A140F] leading-snug">
                  {app.title}
                </h3>
              </div>

              <div className="col-span-12 md:col-span-8 md:border-l md:border-[#E5EBE6] md:pl-10">
                <ol className="space-y-8">
                  {app.steps.map((s) => (
                    <li key={s.n} className="grid grid-cols-12 gap-4">
                      <div className="col-span-2 md:col-span-1 font-mono text-2xl text-[#1A402B]">
                        {s.n}
                      </div>
                      <div className="col-span-10 md:col-span-11">
                        <div className="font-serif text-xl md:text-2xl text-[#0A140F]">
                          {s.partner}
                        </div>
                        <p className="mt-2 font-sans text-base text-[#415248] leading-relaxed">
                          {s.text}
                        </p>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
